// The boat header (TOM-193), as the Neomaris v2 app prototype draws it
// (ui_kits/tombolo-app/Header.jsx): Neo's headline at the left (TOM-526, in
// the quick readings' place), and a glass group holding the mode button at the
// right, which opens the mode selector. At 768 px and under, where the bottom
// bar takes the sidebar's place, a menu button that opens the menu leads the
// header (TOM-513, ADR 0396 §5). It floats over the scrolling content, whose
// top fades into the page ground. The headline is a glass pill (Marina).
import type { NeoStatus, OverviewArchetype } from '@neomaris/protocol';
import type { MouseEvent } from 'react';

import { Icon } from '../ui/Icon';
import { SidebarButton } from './BoatSidebar';
import { NeoHeadline } from './NeoHeadline';

export function modeIcon(archetype: OverviewArchetype | null): string {
  if (archetype === 'underway') return 'underway';
  if (archetype === 'anchored') return 'anchor';
  if (archetype === 'docked') return 'docked';
  return 'auto';
}

export function BoatHeader({
  status,
  onHeadline,
  archetype,
  modeLabel,
  modeOpen,
  menuOpen = false,
  onMode,
  onMenu,
}: {
  /** Neo's status, whose headline the header shows; null until it is read. */
  status: NeoStatus | null;
  /** The headline opens the chat. */
  onHeadline: () => void;
  archetype: OverviewArchetype | null;
  modeLabel: string;
  /** The mode selector is open from this header's mode button. */
  modeOpen: boolean;
  menuOpen?: boolean;
  onMode: (e: MouseEvent<HTMLButtonElement>) => void;
  /** Where there is no sidebar (768 px and under), a menu button leads the header and opens the menu (TOM-513). */
  onMenu?: () => void;
}) {
  return (
    <header className="boat-header">
      {onMenu ? <SidebarButton open={menuOpen} onOpen={onMenu} /> : null}
      <NeoHeadline status={status} onOpen={onHeadline} />
      <div className="tb-glass-group boat-header__group">
        <button
          type="button"
          className="tb-icon-btn boat-header__btn boat-header__btn--mode"
          aria-label={`Boat mode: ${modeLabel}. Change`}
          aria-haspopup="menu"
          aria-expanded={modeOpen}
          title={`Boat mode: ${modeLabel}`}
          data-testid="boat-mode-button"
          onClick={onMode}
        >
          <Icon name={modeIcon(archetype)} size={21} />
        </button>
      </div>
    </header>
  );
}
